module.exports = __webpack_public_path__ + "67909b6ffa4d02f78bf4d8e2c5c294e3.jpg";